/**
 * Core: Lazysizes
 * -----------------------------------------------------------------------------
 * Loosely coupled scripts for responsive and lazy loading images.
 *
 */
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes/plugins/rias/ls.rias'
import 'lazysizes/plugins/respimg/ls.respimg'
import lazySizes from 'lazysizes'

lazySizes.cfg.expFactor = 1.5
